"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthInsurance = void 0;
class HealthInsurance {
    constructor(props) {
        this.active = props?.active;
        this.affiliate_id = props?.affiliate_id;
        this.deleted = false;
        this.endDate = props?.endDate;
        this.id = props?.id;
        this.plan = props?.plan;
        this.primary = props?.primary || false;
        this.timestamps = props?.timestamps;
        this.uid = props?.uid;
        this.userInput = props?.userInput || "";
        this.affiliateType = props?.affiliateType || "";
        this.taxTreatment = props?.taxTreatment || null;
    }
}
exports.HealthInsurance = HealthInsurance;
